import { upperFirst } from 'lodash-es';
import uniqid from 'uniqid';
import { getCityNameFromLocation, getCountryNameByLocale } from './location';
import { LinkData } from './common';
import { NextRouter } from 'next/dist/shared/lib/router/router';

export function getBrowserBreadcrumbsData(slug: string[], locale: string, isLocationBrowser: boolean): LinkData[] {
  const startBreadcrumb = { id: uniqid(), name: isLocationBrowser ? 'Locations' : 'Categories' };
  let breadcrumbs = [{ id: uniqid(), name: 'Home', link: '/' }];
  if (!slug) {
    return [...breadcrumbs, { ...startBreadcrumb, link: null }];
  }
  breadcrumbs = [
    ...breadcrumbs,
    { ...startBreadcrumb, link: isLocationBrowser ? `/${locale}/browser` : `/${locale}/categories` },
  ];

  return slug.reduce((acc, item, index) => {
    const prevUrl = [...acc].pop().link;
    return [
      ...acc,
      { id: uniqid(), name: upperFirst(item), link: slug.length - 1 !== index ? `${prevUrl}/${item}` : null },
    ];
  }, breadcrumbs);
}

export function getProductsBrowserBreadcrumbsData(state: string, product: string, locale: string): LinkData[] {
  const startBreadcrumb = { id: uniqid(), name: 'Locations' };
  const breadcrumbs = [{ id: uniqid(), name: 'Home', link: '/' }];
  if (!state) {
    return [...breadcrumbs, { ...startBreadcrumb, link: null }];
  } else {
    return [
      ...breadcrumbs,
      { ...startBreadcrumb, link: `/${locale}/products/${product}/browser` },
      { id: uniqid(), name: state, link: null },
    ];
  }
}

export function getBreadcrumbsData(router: NextRouter): LinkData[] {
  const { locale, query, route } = router;
  const location = query['location'] as string;
  const params = route.split('/');
  const bc = [
    { id: uniqid(), name: 'Home', link: '/' },
    { id: uniqid(), name: getCountryNameByLocale(locale), link: `/${locale}` },
  ];
  if (location) {
    bc.push({ id: uniqid(), name: getCityNameFromLocation(location), link: `/${locale}/${location}` });
    if (params.includes('flyers') || params.includes('flyer')) {
      const name = locale === 'en-ca' ? 'flyers' : 'weekly_ads';
      bc.push({ id: uniqid(), name: 'Flyers', link: `/${locale}/${location}/${name}` });
    }
    if (params.includes('coupons')) {
      bc.push({ id: uniqid(), name: 'Coupons', link: `/${locale}/${location}/coupons` });
    }
  }
  if (params.includes('stores')) {
    if (location) {
      bc.push({ id: uniqid(), name: 'Stores', link: `/${locale}/${location}/stores` });
    } else {
      bc.push({ id: uniqid(), name: 'Stores', link: `/${locale}/stores` });
    }
  }

  return bc;
}
